const BASE_URL = 'SurveyProvisioning/'

export const LIST_MODULE_TEMPLATES = `${BASE_URL}LIST_MODULE_TEMPLATES`;
export const SAVE_MODULE_TEMPLATES = `${BASE_URL}SAVE_MODULE_TEMPLATES`;
export const SURVEY_SET_DATA = `${BASE_URL}SURVEY_SET_DATA`;
export const GET_HUBS_SURVEYS = `${BASE_URL}GET_HUBS_SURVEYS`;
export const SAVE_NEW_TEMPLATE = `${BASE_URL}SAVE_NEW_TEMPLATE`;
export const FIND_ONE_TEMPLATE = `${BASE_URL}FIND_ONE_TEMPLATE`;
export const DELETE_TEMPLATE = `${BASE_URL}DELETE_TEMPLATE`;
export const SET_LOADING = `${BASE_URL}SET_LOADING`;

export const setData = data => ({
  type: SURVEY_SET_DATA,
  data,
});

export const fetchModuleTemplates = data => ({
  type: LIST_MODULE_TEMPLATES,
  data,
});

export const saveModuleTemplates = data => ({
  type: SAVE_MODULE_TEMPLATES,
  data,
});

export const getHubSurveys = () => ({
  type: GET_HUBS_SURVEYS,
});

export const saveNewTemplate = data => ({
  type: SAVE_NEW_TEMPLATE,
  data,
});

export const findTemplateById = data => ({
  type: FIND_ONE_TEMPLATE,
  data,
});

export const setLoading = data => ({
  type: SET_LOADING,
  data,
});

export const deleteTemplate = data => ({
  type: DELETE_TEMPLATE,
  data,
});

// SELECTORS
export const getSurveyProvisioningState = ({ surveyProvisioningReducer }) =>
  surveyProvisioningReducer;
